<template>
  <v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :type="pw_visible ? 'text' : 'password'"
    autocomplete="new-password" autocapitalize="none"
    :append-icon="pw_visible ? 'mdi-eye-off' : 'mdi-eye'"
    @click:append="pw_visible = !pw_visible"
  />
</template>

<script>
export default {
  name: "PasswordField",
  
  data: () => ({
    pw_visible: false,
  }),
}
</script>